import {cloneDeep} from 'lodash';
import {PanelUtilitiesActions} from '../../models/panel-utilities';
import {FoodGroupAction, FoodGroupState} from '../../models/food-group';
import {ServiceLoopbackFilters} from '../base-service/base.service';
import {ClinicState, IClinic} from '../../models/clinic';
import {StorageService} from '../storage/storage.service';
import {IUser} from '../../models/auth';
import {TourAction, TourState} from '../../models/tour';
import {Store} from '@ngxs/store';
import {Logger} from '../../class/helper/logger.class';
import {EventEmitter, Injectable} from '@angular/core';
import {ShepherdService} from 'angular-shepherd';
import {BehaviorSubject, firstValueFrom, Observable} from 'rxjs';
import {Router} from '@angular/router';
import Step from 'shepherd.js/src/types/step';
import {ToursEnum} from '../../enums/tour';
import {UserService} from '../user/user.service';
import {AppointmentActions} from '../../models/appointment';
import {UtilitiesService} from '../utilities-service/utilities.service';
import {LocalStorageEnum} from '../../enums/utils';
import {Loader} from '../../models/loader/loader.redux';
import {NzModalService} from 'ng-zorro-antd/modal';
import {PlanActions, PlanState} from '../../models/plan';
import {PatientAction} from '../../models/patient';
import {PatientSphereAction} from '../../models/patient-sphere';
import {MealPlanActions} from '../../models/meal-plans';
import {ICredentials} from '../../interfaces/credentials';
import {
  assignCreateMealPlanStep,
  assignMealPlanBuilderSelectStep,
  assignMealPlanPatientStep,
  assignMealPlanSelectStep,
  goToScheduleStep,
  viewSchedulesStep,
  goToFoodDishesStep,
  registerFoodDishMenuStep,
  registerFoodDishStep,
  startAdviceStep,
  adviceStep,
  goToPatientsStep,
  registerPatientStep,
  finishRegisterPatientStep,
  workSchedulesStep,
  createAppointmentFromConsultationStep,
  createAppointmentFromHomeStep,
  branchStep,
  goToMealPlansStep,
  registerMealPlanNoFoodDishesStep,
  workSchedulesOnlyExpertSteps,
  workSchedulesOnlyExpertWithoutPermisionEditStep,
  registerMelPlanPartTwoStep,
} from '../../config/data/tour';
import {offset} from '@floating-ui/dom';

export interface ITourExpert {
  registerPatient: boolean;
  scheduleAppointment: boolean;
  checkSchedule: boolean;
  registerFoodDish: boolean;
  registerMealPlan: boolean;
}
@Injectable({
  providedIn: 'root'
})
export class AppTourService {
  events: EventEmitter<string> = new EventEmitter<string>();

  // tslint:disable:typedef
  // tslint:disable:prefer-const
  // tslint:disable:forin
  // tslint:disable:object-literal-shorthand
  // tslint:disable:only-arrow-functions
  // tslint:disable:space-before-function-paren
  tourMode: boolean;
  requiredMainMenu: boolean;
  tours: ITourExpert = {
    registerPatient: false,
    scheduleAppointment: false,
    checkSchedule: false,
    registerFoodDish: false,
    registerMealPlan: false
  };

  defaultStepOptions: Step.StepOptions = {
    classes: 'shepherd-theme-square',
    cancelIcon: {
      enabled: true
    },
    scrollTo: {
      inline: 'end',
      block: 'nearest',
      behavior: 'smooth',
    },
    modalOverlayOpeningPadding: 5,
    modalOverlayOpeningRadius: 5,
    floatingUIOptions: {
      middleware: [offset({ mainAxis: 16, crossAxis: 16 })]
    }
  };

  floatingUIOptions: Step.StepOptions = {
    // @ts-ignore
    floatingUIOptions: {
      middleware: [offset({ mainAxis: 16, crossAxis: 16 })]
    },
  };

  cancelButton: Step.StepOptionsButton = {
    classes: 'shepherd-cancel-button',
    text: '&#88;',
    action: () => {
      this.shepherdService.tourObject.getCurrentStep().hide();
      this.modal.confirm({
        nzTitle: '¿Estás seguro de cancelar el tour?',
        nzContent: this.storageService.getLocalItem(LocalStorageEnum.FORCE_TOUR_NAME) ?
          'Si deseas volver a hacer el tour, puedes iniciarlo desde la página "Tours".' :
          'Una vez hecho, se redirigirá a la vista principal para que pueda comenzar a utilizar la plataforma sin guía. ',
        nzOkText: 'SÍ QUIERO CANCELARLO',
        nzCancelText: 'NO QUIERO',
        nzOkDanger: true,
        nzClassName: 'modal-confirm',
        nzClosable: false,
        nzOnOk: async () => {
          await firstValueFrom(this.store.dispatch(new Loader(true, 'Cancelando tour...')));
          this.events.emit('closeElements');
          this.requiredMainMenu = false;
          await this.openMenu(false);
          // No mover la siguiente línea porque se borra el LS en el método completeTour
          const forceTourName = this.storageService.getLocalItem(LocalStorageEnum.FORCE_TOUR_NAME);

          const user = this.storageService.getLocalItem<{ user: IUser, token: string }>('user').user;
          const clinicId = this.userService.getClinicIdFromUser(user);

          this.utilitiesServiceService.showOrHideTypebot(true);

          await this.completeAllTour(); // this.shepherdService.tourName

          if (forceTourName) {
            // Redirecciona al listado de tours
            await firstValueFrom(this.store.dispatch(new Loader(false)));
            await this.router.navigate(['/', 'clinic', clinicId, 'profile', 'expert', 'me', 'tours']);
          } else if (this.shepherdService.tourName === ToursEnum.ADVICE) {
            // Tour de asesoría
            await firstValueFrom(this.store.dispatch(new PatientSphereAction.ShowOrHideBubble(true)));
            await this.router.navigate([]); // Para que recargue el componente de summary-page
            await this.router.navigateByUrl(`/clinic/${clinicId}/summary/`, {replaceUrl: true});
          } else if (this.shepherdService.tourName === ToursEnum.ASSIGN_SELECT_MEAL_PLAN) {
            await firstValueFrom(this.store.dispatch(new PatientSphereAction.ShowOrHideBubble(true)));
          }

          // no mover esta línea porque ocupa finalizar el tour hasta el final de este bloque
          // para que no aparezca el modal de confirmación para abandonar el plan de alimentación en el guard CanLeaveMealPlansGuard
          await this.completeService();
          await firstValueFrom(this.store.dispatch(new Loader(false)));
        },
        nzOnCancel: () => {
          this.shepherdService.tourObject.getCurrentStep().show();
        },
      });
    }
  };

  stepOption: Step.StepOptions = {
    cancelIcon: {enabled: false},
    beforeShowPromise: function () {
      return new Promise(function (resolve) {
        setTimeout(function () {
          resolve(true);
        }, 500);
      });
    },
    buttons: [
      {
        action() {
          return this.next();
        },
        text: 'Siguiente'
      },
      {
        ...this.cancelButton,
      }
    ],
    modalOverlayOpeningPadding: 5,
    modalOverlayOpeningRadius: 5,
    // @ts-ignore
    popperOptions: {
      modifiers: [{
        name: 'offset',
        options: {
          offset: [
            16,
            16
          ]}
      }]
    },
  };

  private isCollapsedMenu: BehaviorSubject<boolean | null>;
  private urlView = '';

  constructor(
    public shepherdService: ShepherdService,
    private store: Store,
    private storageService: StorageService,
    private modal: NzModalService,
    private router: Router,
    private userService: UserService,
    private utilitiesServiceService: UtilitiesService,
  ) {

    this.isCollapsedMenu = new BehaviorSubject(null);
  }

  // abre el módulo de mis planes de alimentación
  startTourGoToMealPlans() {
    this.completeService();
    this.shepherdService.modal = true;
    this.shepherdService.defaultStepOptions = this.defaultStepOptions;
    // @ts-ignore
    // @ts-ignore
    // @ts-ignore
    this.shepherdService.addSteps(goToMealPlansStep({
      steps: {default: this.stepOption},
      buttons: {cancel: this.cancelButton},
    }));
    this.shepherdService.modal = true;
    this.shepherdService.confirmCancel = false;
    this.shepherdService.start();
  }

  // // abre el módulo de mis pacientes
  startTourGoToPatients() {
    this.shepherdService.tourName = ToursEnum.REGISTER_PATIENT;
    this.completeService();
    this.shepherdService.modal = true;
    this.shepherdService.defaultStepOptions = this.defaultStepOptions;
    this.shepherdService.addSteps(goToPatientsStep({
      steps: {default: this.stepOption},
      buttons: {cancel: this.cancelButton},
    }));
    this.shepherdService.modal = true;
    this.shepherdService.confirmCancel = false;
    this.shepherdService.start();
  }

  // abre el módulo de mi agenda
  startTourGoToSchedule() {
    this.shepherdService.tourName = ToursEnum.CHECK_SCHEDULE;
    this.requiredMainMenu = true;
    this.openMenu(true).then();
    this.completeService();
    this.shepherdService.defaultStepOptions = this.defaultStepOptions;
    this.shepherdService.modal = true;
    this.shepherdService.addSteps(goToScheduleStep({
      steps: {default: this.stepOption},
      buttons: {cancel: this.cancelButton},
    }));
    this.shepherdService.confirmCancel = false;
    this.shepherdService.start();
  }

  // abre el módulo de mis recetas
  startTourGoToFoodDishes() {
    this.shepherdService.tourName = ToursEnum.REGISTER_FOOD_DISH;
    this.completeService();
    this.shepherdService.modal = true;
    this.shepherdService.defaultStepOptions = this.defaultStepOptions;
    this.shepherdService.addSteps(goToFoodDishesStep({
      steps: {default: this.stepOption},
      buttons: {cancel: this.cancelButton},
    }));
    this.shepherdService.modal = true;
    this.shepherdService.confirmCancel = false;
    this.shepherdService.start();
  }

  /**
   * abre el módulo de Administración
   * @param title
   */
  startTourGoToAdministration(title: string) {
    this.shepherdService.tourName = title === '¡Vamos a crear un horario de trabajo!' ? ToursEnum.SCHEDULES : ToursEnum.REGISTER_BRANCH;

    this.completeService();
    this.shepherdService.modal = true;
    this.shepherdService.defaultStepOptions = this.defaultStepOptions;
    this.shepherdService.addSteps([
      {
        ...this.floatingUIOptions,
        cancelIcon: {enabled: false},
        id: 'startGoToAdministration',
        title,
        text: `Da clic en "Administración" para poder continuar.`,
        attachTo: {
          element: '.l-item-3-2',    // @ts-ignore
          on: 'bottom'
        },
        advanceOn: {
          selector: '.l-item-3-2',
          event: 'click'
        },
        buttons: [
          {
            ...this.cancelButton,
          }
        ],
        beforeShowPromise: async () => {
          await firstValueFrom(this.store.dispatch(new PanelUtilitiesActions.SetIsVisible(true)));
          return this.beforeShowPromise(1000);
        }, // Comprobar que se abra el panel de utilidades
        classes: 'shepherd shepherd-open shepherd-theme-square shepherd-transparent-text',
      }
    ]);
    this.shepherdService.modal = true;
    this.shepherdService.confirmCancel = false;
    this.shepherdService.start();
  }

  startTourGotoProfile(title: string) {
    this.shepherdService.tourName = title === '¡Vamos a revisar los horarios de trabajo!' ? ToursEnum.EXPERT_SCHEDULES : undefined;

    this.completeService();
    this.shepherdService.modal = true;
    this.shepherdService.defaultStepOptions = this.defaultStepOptions;
    this.shepherdService.addSteps([
      {
        ...this.floatingUIOptions,
        cancelIcon: {enabled: false},
        id: 'startGoToAdministration',
        title,
        text: `Da clic en "Mi perfil" para poder continuar.`,
        attachTo: {
          element: '.l-item-3-1',    // @ts-ignore

          on: 'bottom'
        },
        advanceOn: {
          selector: '.l-item-3-1',
          event: 'click'
        },
        buttons: [
          {
            ...this.cancelButton,
          }
        ],
        beforeShowPromise: async () => {
          await firstValueFrom(this.store.dispatch(new PanelUtilitiesActions.SetIsVisible(true)));
          return this.beforeShowPromise(1000);
        }, // Comprobar que se abra el panel de utilidades
        classes: 'shepherd shepherd-open shepherd-theme-square shepherd-transparent-text',
      }
    ]);
    this.shepherdService.modal = true;
    this.shepherdService.confirmCancel = false;
    this.shepherdService.start();
  }

  /**
   * Crear cita desde el home
   * Tour web completed
   */
  startTourNewAppointmentFromHomePage() {
    this.shepherdService.tourName = ToursEnum.SCHEDULE_APPOINTMENT;
    this.completeService();
    this.shepherdService.modal = true;
    this.shepherdService.defaultStepOptions = this.defaultStepOptions;
    const forceTourName = this.storageService.getLocalItem(LocalStorageEnum.FORCE_TOUR_NAME);

    const steps: Step.StepOptions[] = createAppointmentFromHomeStep({
      steps: {default: this.stepOption},
      buttons: {cancel: this.cancelButton},
      services: {utilitiesService: this.utilitiesServiceService},
    });

    const goToScheduleSteps: Step.StepOptions = {
      ...this.stepOption,
      scrollTo: {
        inline: 'end',
        block: 'center',
        behavior: 'smooth',
      },
      id: 'newAppointmentStep11',
      title: 'Finalizar el registro de la cita',
      text: `Da clic en el botón para guardar y agendar la cita DEMO.`,
      attachTo: {
        element: '.btn-save-appointment',
        on: 'top'
      },
      advanceOn: {
        selector: '.btn-save-appointment',
        event: 'click'
      },
      buttons: [{...this.cancelButton}],
      classes: 'shepherd shepherd-open shepherd-theme-square shepherd-transparent-text',
    };

    const finishRegisterAppointment: Step.StepOptions[] = [
      {
        ...this.stepOption,
        id: 'newAppointmentStep12',
        title: 'Crear cita',
        text: 'Una vez que hayas ingresado los datos tendrás que dar clic en el botón para poder guardar la cita. Para fines del tour, se eliminarán los datos de la cita DEMO.',
        canClickTarget: false,
        attachTo: {
          element: '.btn-save-appointment',    // @ts-ignore

          on: 'top'
        },
        buttons: [
          {
            text: 'Entendido',
            action: function ()  {
              this.next();
            },
          },
          {...this.cancelButton},
        ]
      },
      {
        ...this.stepOption,
        id: 'newAppointmentStep13',
        title: 'Tour finalizado',
        // text: '¡Muy bien!. Ya conoces la forma de registrar sucursales, ahora solo te queda registrarlas.',
        text: '¡Muy bien!. Has finalizado el tour de "Crear cita".',
        canClickTarget: false,
        buttons: [
          {
            action: () => {
              this.completeTour(ToursEnum.SCHEDULE_APPOINTMENT).finally(async () => {
                await this.completeService();
                const {user} = this.storageService.getLocalItem<ICredentials>(LocalStorageEnum.USER);
                if (!user) return;
                const clinicId = this.userService.getClinicIdFromUser(user);
                await this.router.navigate(['/', 'clinic', clinicId, 'profile', 'expert', 'me', 'tours']);
              });
            },
            text: 'Ir al listado de tours',
            classes: 'shepherd-button shepherd-button-secondary',
          },
          {
            action: () => {
              this.completeTour(ToursEnum.SCHEDULE_APPOINTMENT).finally(async () => {
                await this.completeService();
                this.events.emit('closeModalHomeModalCreateAppointment');
              });
            },
            text: 'Mantenerme aquí'
          },
          {...this.cancelButton}
        ]
      }
    ];

    const concatSteps = steps.concat(forceTourName ? finishRegisterAppointment : [goToScheduleSteps]);

    this.shepherdService.addSteps(concatSteps);
    this.shepherdService.confirmCancel = false;
    this.shepherdService.start();
  }

  //
  /**
   * Tour web completed
   * @description desde los detalles del paciente se quiere crear una cita
   */
  startTourNewAppointmentFromConsultation() {
    this.shepherdService.tourName = ToursEnum.SCHEDULE_APPOINTMENT;
    this.completeService();
    this.shepherdService.modal = true;
    this.shepherdService.defaultStepOptions = this.defaultStepOptions;
    this.shepherdService.addSteps(createAppointmentFromConsultationStep({
      steps: {default: this.stepOption},
      buttons: {cancel: this.cancelButton},
    }));
    this.shepherdService.confirmCancel = false;
    this.shepherdService.start();
  }

  /**
   * Tour web completed
   * @description registra un nuevo paciente
   */
  startTourRegisterPatientSteps() {
    this.shepherdService.tourName = ToursEnum.REGISTER_PATIENT;
    const forceTourName = this.storageService.getLocalItem(LocalStorageEnum.FORCE_TOUR_NAME);
    this.completeService();
    this.shepherdService.modal = true;
    this.shepherdService.defaultStepOptions = this.defaultStepOptions;
    const that = this;
    // Crea un usuario demo, crea cita y finaliza en agenda
    const goToCreateAppointmentStep: Step.StepOptions = {
      ...this.stepOption,
      scrollTo: {
        inline: 'end',
        block: 'center',
        behavior: 'smooth',
      },
      id: 'registerPatientStep4',
      title: '¡Ya casi acabamos!',
      text: `Solo debes asegurarte de que los campos sean válidos y podrás dar clic en guardar a tu paciente. Para fines del tour se registrará un paciente DEMO, solo da clic en "Entendido" para finalizar. ¡Bien hecho!`,
      attachTo: {
        element: '.btn-register',    // @ts-ignore

        on: 'bottom'
      },
      advanceOn: {
        selector: '.btn-register',
        event: 'click'
      },
      classes: '',
      buttons: [{...this.cancelButton}],
    };
    // Solo explica la creación de pacientes y finaliza el tour
    const finishTourSteps: Step.StepOptions[] = finishRegisterPatientStep({
      steps: {default: this.stepOption},
      buttons: {cancel: this.cancelButton},
      cb(value) {
        switch (value) {
          case 'goToTours':
            that.completeTour(ToursEnum.REGISTER_PATIENT).finally(async () => {
              await that.completeService();
              const {user} = that.storageService.getLocalItem<ICredentials>(LocalStorageEnum.USER);
              if (!user) return;
              const clinicId = that.userService.getClinicIdFromUser(user);
              await that.router.navigate(['/', 'clinic', clinicId, 'profile', 'expert', 'me', 'tours']);
            });
            break;
          case 'continue':
            that.completeTour(ToursEnum.REGISTER_PATIENT).finally(async () => {
              await that.completeService();
            });
            break;
        }
      }
    });
    const steps: Step.StepOptions[] = registerPatientStep({
      steps: {default: this.stepOption},
      buttons: {cancel: this.cancelButton},
    });
    const concatSteps = steps.concat(forceTourName ? finishTourSteps : [goToCreateAppointmentStep]);
    this.shepherdService.addSteps(concatSteps);
    this.shepherdService.confirmCancel = false;
    this.shepherdService.start();
  }

  /**
   * Tour web completed
   * @description ver las citas en la agenda
   */
  startTourViewSchedulesSteps() {
    this.shepherdService.tourName = ToursEnum.CHECK_SCHEDULE;
    this.completeService();
    // solo puede mostrarse este tour cuando ya se tiene paciente y cita demo
    // if (!this.tours.registerPatient || !this.tours.scheduleAppointment) return;
    const that = this;
    this.shepherdService.defaultStepOptions = this.defaultStepOptions;
    this.shepherdService.modal = true;
    this.shepherdService.addSteps(viewSchedulesStep({
        steps: {default: this.stepOption},
        buttons: {cancel: this.cancelButton},
        services: {utilitiesService: this.utilitiesServiceService, storageService: this.storageService},
        async cb(): Promise<void> {
          await firstValueFrom(that.store.dispatch(new Loader(true, 'Finalizando tour...')));
          const clinic: IClinic = cloneDeep(await firstValueFrom((that.store.selectOnce(ClinicState.getClinicSelected))));
          const forceTourName = that.storageService.getLocalItem(LocalStorageEnum.FORCE_TOUR_NAME);
          await that.completeTour(ToursEnum.CHECK_SCHEDULE);
          that.completeService();
          if (forceTourName === ToursEnum.CHECK_SCHEDULE) {
            // Va a continuar con el tour de crear receta
            await that.showTour('dashboard-expert'); // En el switch de este método está la prioridad de los tours
          } else {
            await that.router.navigate(['/', 'clinic', clinic?._id, 'summary']);
          }
          await firstValueFrom(that.store.dispatch(new Loader(false)));
        }
    }));
    this.shepherdService.modal = true;

    this.shepherdService.confirmCancel = false;
    this.shepherdService.start();
  }

  /**
   * Crear grupo de horarios
   * Tour web completed
   */
  startTourWorkSchedulesSteps() {
    this.shepherdService.tourName = ToursEnum.EXPERT_SCHEDULES;
    this.completeService();
    this.utilitiesServiceService.showOrHideTypebot(false);
    const that = this;
    this.shepherdService.defaultStepOptions = this.defaultStepOptions;
    this.shepherdService.modal = true;
    this.shepherdService.addSteps(workSchedulesStep({
      steps: {default: this.stepOption},
      buttons: {cancel: this.cancelButton},
      services: {utilitiesService: this.utilitiesServiceService, storageService: this.storageService, store: this.store},
      async cb(value: string): Promise<void> {
        switch(value) {
          case 'createSchedule':
            if (that.storageService.getLocalItem(LocalStorageEnum.FORCE_TOUR_NAME) !== ToursEnum.SCHEDULES) {
              // Si está haciendo el tour como usuario nuevo, completa este tour y comienza el tour de crear paciente
              await that.store.dispatch(new Loader(true, 'Completando tour'));
              await that.completeTour(ToursEnum.SCHEDULES);
              that.utilitiesServiceService.showOrHideTypebot(true);
              await that.showTour('dashboard-expert'); // En el switch de este método es donde se define que tour es el siguiente
              await that.store.dispatch(new Loader(false));
            }
            break;
          case 'tourFinished':
            that.completeTour(ToursEnum.SCHEDULES).finally(async () => {
              await that.completeService();
              const {user} = that.storageService.getLocalItem<ICredentials>(LocalStorageEnum.USER);
              if (!user) return;
              const clinicId = that.userService.getClinicIdFromUser(user);
              await that.router.navigate(['/', 'clinic', clinicId, 'profile', 'expert', 'me', 'tours']);
              that.utilitiesServiceService.showOrHideTypebot(true);
            });
            break;
          case 'keepMeHere':
            that.completeTour(ToursEnum.SCHEDULES).finally(async (): Promise<void> => {
              await that.completeService();
              that.utilitiesServiceService.showOrHideTypebot(true);
            });
            break;
        }
      }
    }));
    this.shepherdService.confirmCancel = false;
    this.shepherdService.start();
  }

  /**
   * Crear grupo de horarios solo como experto cuando la clínica permite hacer horario
   * Tour web completed
   */
  startTourWorkSchedulesOnlyExpertSteps() {
    this.shepherdService.tourName = ToursEnum.SCHEDULES;
    this.completeService();
    this.utilitiesServiceService.showOrHideTypebot(false);
    const that = this;
    this.shepherdService.defaultStepOptions = this.defaultStepOptions;
    this.shepherdService.modal = true;
    this.shepherdService.addSteps(workSchedulesOnlyExpertSteps({
      steps: {default: this.stepOption},
      buttons: {cancel: this.cancelButton},
      services: {utilitiesService: this.utilitiesServiceService, store: this.store},
      async cb(value: string): Promise<void> {
        switch(value) {
          case 'createWorkSchedule':
            if (that.storageService.getLocalItem(LocalStorageEnum.FORCE_TOUR_NAME) !== ToursEnum.EXPERT_SCHEDULES) {
              // Si está haciendo el tour como usuario nuevo, completa este tour y comienza el tour de crear paciente
              await that.store.dispatch(new Loader(true, 'Completando tour'));
              await that.completeTour(ToursEnum.EXPERT_SCHEDULES);
              that.utilitiesServiceService.showOrHideTypebot(true);
              await that.showTour('dashboard-expert'); // En el switch de este método es donde se define que tour es el siguiente
              await that.store.dispatch(new Loader(false));
            }
            break;
          case 'goToTours':
            that.completeTour(ToursEnum.EXPERT_SCHEDULES).finally(async () => {
              await that.completeService();
              const {user} = that.storageService.getLocalItem<ICredentials>(LocalStorageEnum.USER);
              if (!user) return;
              const clinicId = that.userService.getClinicIdFromUser(user);
              await that.router.navigate(['/', 'clinic', clinicId, 'profile', 'expert', 'me', 'tours']);
              that.utilitiesServiceService.showOrHideTypebot(true);
            });
            break;
          case 'keepMeHere':
            that.completeTour(ToursEnum.EXPERT_SCHEDULES).finally(async () => {
              await that.completeService();
              that.utilitiesServiceService.showOrHideTypebot(true);
            });
            break;
        }
      }
    }));
    this.shepherdService.confirmCancel = false;
    this.shepherdService.start();
  }

  /**
   * Crear grupo de horarios solo como experto cuando la clínica no permite editar el horario
   * Tour web completed
   */
  startTourWorkSchedulesOnlyExpertWithoutPermissionToEditSteps() {
    this.shepherdService.tourName = ToursEnum.SCHEDULES;
    this.completeService();
    this.utilitiesServiceService.showOrHideTypebot(false);
    const that = this;
    this.shepherdService.defaultStepOptions = this.defaultStepOptions;
    this.shepherdService.modal = true;
    this.shepherdService.addSteps(workSchedulesOnlyExpertWithoutPermisionEditStep({
      steps: {default: this.stepOption},
      buttons: {cancel: this.cancelButton},
      services: {utilitiesService: this.utilitiesServiceService, store: this.store},
      async cb(value: string) {
        switch(value) {
          case 'addException':
            if (this.storageService.getLocalItem(LocalStorageEnum.FORCE_TOUR_NAME) !== ToursEnum.EXPERT_SCHEDULES) {
              await that.store.dispatch(new Loader(true, 'Completando tour'));
              await that.completeTour(ToursEnum.EXPERT_SCHEDULES);
              that.utilitiesServiceService.showOrHideTypebot(true);
              await that.showTour('dashboard-expert'); // En el switch de este método es donde se define que tour es el siguiente
              await that.store.dispatch(new Loader(false));
            }
            break;
          case 'goToTours':
            that.completeTour(ToursEnum.EXPERT_SCHEDULES).finally(async () => {
              await that.completeService();
              const {user} = that.storageService.getLocalItem<ICredentials>(LocalStorageEnum.USER);
              if (!user) return;
              const clinicId = that.userService.getClinicIdFromUser(user);
              await that.router.navigate(['/', 'clinic', clinicId, 'profile', 'expert', 'me', 'tours']);
              that.utilitiesServiceService.showOrHideTypebot(true);
            });
            break;
          case 'keepMeHere':
            that.completeTour(ToursEnum.EXPERT_SCHEDULES).finally(async () => {
              await that.completeService();
              that.utilitiesServiceService.showOrHideTypebot(true);
            });
            break;
        }
      }
    }))
    this.shepherdService.confirmCancel = false;
    this.shepherdService.start();
  }

  startTourAdvice(): void {
    this.shepherdService.tourName = ToursEnum.ADVICE;
    this.completeService();

    const that = this;
    this.shepherdService.defaultStepOptions = this.defaultStepOptions;
    this.shepherdService.modal = true;
    this.shepherdService.addSteps(startAdviceStep({
      steps: {default: this.stepOption},
      buttons: {cancel: this.cancelButton},
      services: {utilitiesService: this.utilitiesServiceService, store: this.store},
    }));
    this.shepherdService.confirmCancel = false;
    this.shepherdService.start();
  }

  /**
   *
   */
  startTourAdviceSteps(): void {
    setTimeout(() => {
      this.utilitiesServiceService.showOrHideTypebot(false);
    }, 1000);
    this.shepherdService.tourName = ToursEnum.ADVICE;
    this.completeService();
    const that = this;
    this.shepherdService.defaultStepOptions = this.defaultStepOptions;
    this.shepherdService.modal = true;
    this.shepherdService.addSteps(adviceStep({
      steps: {default: this.stepOption},
      buttons: {cancel: this.cancelButton},
      services: {utilitiesService: this.utilitiesServiceService},
      events: {events: this.events},
      async cb(value: string): Promise<void> {
        const {user} = that.storageService.getLocalItem<ICredentials>(LocalStorageEnum.USER);
        if (!user) return;
        const clinicId = that.userService.getClinicIdFromUser(user);
        await firstValueFrom(that.store.dispatch(new TourAction.CreateDemoPatient(clinicId)));
        const demoPatient = await firstValueFrom(that.store.selectOnce(TourState.getDemoPatientCreated));
        switch (value) {
          case 'createPlan':
            await firstValueFrom(that.store.dispatch(new Loader(true, 'Cargando el tour...')));
            if (!demoPatient) return;
            await that.completeTour(ToursEnum.ADVICE, false);
            await that.completeService();
            // START TOUR CREATE MEAL PLAN
            that.storageService.setLocalItem(LocalStorageEnum.FORCE_TOUR_NAME, ToursEnum.ASSIGN_CREATE_MEAL_PLAN);
            await that.router.navigate(['/', 'clinic', clinicId, 'patients', demoPatient._id, 'meal-plans']);
            await firstValueFrom(that.store.dispatch(new Loader(false)));
            break;
          case 'selectPlan':
            await firstValueFrom(that.store.dispatch(new Loader(true, 'Cargando el tour...')));
            await firstValueFrom(that.store.dispatch(new TourAction.CreateDemoPatient(clinicId)));
            if (!demoPatient) return;
            await that.completeTour(ToursEnum.ADVICE, false);
            await that.completeService();
            // START TOUR SELECT MEAL PLAN
            that.storageService.setLocalItem(LocalStorageEnum.FORCE_TOUR_NAME, ToursEnum.ASSIGN_SELECT_MEAL_PLAN);
            await that.router.navigate(['/', 'clinic', clinicId, 'patients', demoPatient._id, 'meal-plans']);
            await firstValueFrom(that.store.dispatch(new Loader(false)));
            break;
          case 'tourFinished':
            const forceTourName = that.storageService.getLocalItem(LocalStorageEnum.FORCE_TOUR_NAME);
            that.completeTour(ToursEnum.ADVICE).finally(async () => {
              await firstValueFrom(that.store.dispatch(new Loader(true, 'Finalizando tour...')));
              await firstValueFrom(that.store.dispatch(new PatientSphereAction.ShowOrHideBubble(true)));
              that.utilitiesServiceService.showOrHideTypebot(true);
              await that.completeService();
              if (forceTourName) {
                await that.router.navigate(['/', 'clinic', clinicId, 'profile', 'expert', 'me', 'tours']);
              } else {
                await that.router.navigate(['/', 'clinic', clinicId , 'summary']);
              }
              await firstValueFrom(that.store.dispatch(new Loader(false)));
            });
            break;
        }
      }
    }));
    this.shepherdService.confirmCancel = true;
    this.shepherdService.start();
  }

  /**
   * Crear una sucursal
   * Tour web completed
   */
  startTourBranchSteps() {
    this.shepherdService.tourName = ToursEnum.REGISTER_BRANCH;
    this.completeService();
    const that = this;
    this.shepherdService.defaultStepOptions = this.defaultStepOptions;
    this.shepherdService.modal = true;
    this.shepherdService.addSteps(branchStep({
      steps: {default: this.stepOption},
      buttons: {cancel: this.cancelButton},
      services: {utilitiesService: this.utilitiesServiceService, store: this.store},
      events: {events: this.events},
      async cb(value: string) {
        switch(value) {
          case 'goToTours':
            that.completeTour(ToursEnum.REGISTER_BRANCH).finally(async () => {
              await that.completeService();
              const {user} = that.storageService.getLocalItem<ICredentials>(LocalStorageEnum.USER);
              if (!user) return;
              const clinicId = that.userService.getClinicIdFromUser(user);
              await that.router.navigate(['/', 'clinic', clinicId, 'profile', 'expert', 'me', 'tours']);
            });
            break;
          case 'keepMeHere':
            that.completeTour(ToursEnum.REGISTER_BRANCH).finally(async () => {
              await that.completeService();
            }); // 'registerBranch'
            break;
        }
      }
    }));
    this.shepherdService.confirmCancel = false;
    this.shepherdService.start();
  }

  /**
   * Invitar a crear una receta
   * Tour web completed
   */
  startTourRegisterFoodDishMenu() {
    this.shepherdService.tourName = ToursEnum.REGISTER_FOOD_DISH;
    this.completeService();
    this.shepherdService.defaultStepOptions = this.defaultStepOptions;
    this.shepherdService.modal = true;
    this.shepherdService.addSteps(registerFoodDishMenuStep({
      steps: {default: this.stepOption},
      buttons: {cancel: this.cancelButton},
    }));
    this.shepherdService.confirmCancel = false;
    this.shepherdService.start();
  }

  /**
   * Create a new FoodGroup tour
   * Tour web completed
   */
  startTourRegisterFoodDishSteps() {
    this.shepherdService.tourName = ToursEnum.REGISTER_FOOD_DISH;
    const that = this;
    this.completeService();
    this.shepherdService.defaultStepOptions = this.defaultStepOptions;
    this.shepherdService.modal = true;
    this.shepherdService.addSteps(registerFoodDishStep({
      steps: {default: this.stepOption},
      buttons: {cancel: this.cancelButton},
      services: {utilitiesService: this.utilitiesServiceService, storageService: this.storageService},
      events: {events: this.events},
      async cb(value: string): Promise<void>  {
        switch (value) {
          case 'saveRecipe':
            // El siguiente tour es el de crear plan de alimentación
            await that.store.dispatch(new Loader(true, 'Completando tour'));
            await that.completeTour(ToursEnum.REGISTER_FOOD_DISH);
            this.complete(); // CHECAR ESTA PARTE
            await that.showTour('dashboard-expert'); // En el switch de esté método esta el orden de los tours
            await that.store.dispatch(new Loader(false));
            break;
          case 'goToTours':
            that.completeTour(ToursEnum.REGISTER_FOOD_DISH).finally(async () => {
              await that.completeService();
              const {user} = that.storageService.getLocalItem<ICredentials>(LocalStorageEnum.USER);
              if (!user) return;
              const clinicId = that.userService.getClinicIdFromUser(user);
              await that.router.navigate(['/', 'clinic', clinicId, 'profile', 'expert', 'me', 'tours']);
            });
            break;
          case 'completeTour':
            that.completeTour(ToursEnum.REGISTER_FOOD_DISH).finally(async () => {
              await that.completeService();
            });
            break;
        }
      }
    }));
    this.shepherdService.confirmCancel = false;
    this.shepherdService.start();
  }

  /**
   * invitar a crear un plan de alimentación
   */
  startTourRegisterMealPlanMenu() {
    this.shepherdService.tourName = ToursEnum.REGISTER_MEAL_PLAN;
    this.completeService();
    this.shepherdService.defaultStepOptions = this.defaultStepOptions;
    this.shepherdService.modal = true;
    this.shepherdService.addSteps([
      {
        ...this.stepOption,
        id: 'registerMealPlanStep1',
        title: 'Agrega tu primer plan de alimentación',
        text: `Da clic en el botón para abrir el editor de planes de alimentación y comenzar a construir tu primer plan.`,
        attachTo: {
          element: '.btn-add-meal-plan',
          on: 'bottom'
        },
        advanceOn: {
          selector: '.btn-add-meal-plan',
          event: 'click'
        },
        buttons: [{...this.cancelButton}],
        beforeShowPromise: async () => {
          return this.beforeShowPromise(1000);
        },
      }
    ]);
    this.shepherdService.confirmCancel = false;
    this.shepherdService.start();
  }

  /**
   * Crea un plan de alimentación - Flujo con recetas
   * Tour web completed
   */
  startTourRegisterMealPlanPartTwo() {
    this.shepherdService.tourName = ToursEnum.REGISTER_MEAL_PLAN;
    const that = this;
    this.completeService();
    this.shepherdService.defaultStepOptions = this.defaultStepOptions;
    this.shepherdService.modal = true;
    this.shepherdService.addSteps(registerMelPlanPartTwoStep({
      steps: {default: this.stepOption},
      buttons: {cancel: this.cancelButton},
      services: {utilitiesService: this.utilitiesServiceService, storageService: this.storageService},
      events: {events: this.events},
      async cb(value: string) {
        switch(value) {
          case 'createMealPlan':
            if (that.storageService.getLocalItem(LocalStorageEnum.FORCE_TOUR_NAME) !== ToursEnum.REGISTER_MEAL_PLAN) {
              await that.store.dispatch(new Loader(true, 'Completando tour'));
              await that.completeTour(ToursEnum.REGISTER_MEAL_PLAN);
              const {user} = that.storageService.getLocalItem<ICredentials>(LocalStorageEnum.USER);
              if (!user) return;
              const clinicId = that.userService.getClinicIdFromUser(user);
              await that.router.navigate(['/', 'clinic', clinicId, 'summary']);
              // await that.showTour('dashboard-expert'); // En el switch de este método es donde se define que tour es el siguiente
              await that.store.dispatch(new Loader(false));
            }
            break;
          case 'goToTours':
            that.completeTour(ToursEnum.REGISTER_MEAL_PLAN).finally(async () => {
              await that.completeService();
              const {user} = that.storageService.getLocalItem<ICredentials>(LocalStorageEnum.USER);
              if (!user) return;
              const clinicId = that.userService.getClinicIdFromUser(user);
              await that.router.navigate(['/', 'clinic', clinicId, 'profile', 'expert', 'me', 'tours']);
            });
            break;
          case 'keepMeHere':
            that.completeTour(ToursEnum.REGISTER_MEAL_PLAN).finally(async () => {
              await that.completeService();
            });
            break;
        }
      }
    }));
    this.shepherdService.confirmCancel = false;
    this.shepherdService.start();
  }

  /**
   * Crea un plan de alimentación - Cuando no hay recetas
   * Tour web completed
   */
  startTourRegisterMealPlanPartNotFoodDishes() {
    this.shepherdService.tourName = ToursEnum.REGISTER_MEAL_PLAN;
    this.completeService();
    const that = this;
    this.shepherdService.defaultStepOptions = this.defaultStepOptions;
    this.shepherdService.modal = true;
    this.shepherdService.addSteps(registerMealPlanNoFoodDishesStep({
      steps: {default: this.stepOption},
      buttons: {cancel: this.cancelButton},
      services: {utilitiesService: this.utilitiesServiceService},
      events: {events: this.events},
      async cb(value: string) {
        const {user} = that.storageService.getLocalItem<ICredentials>(LocalStorageEnum.USER);
        const clinicId = that.userService.getClinicIdFromUser(user);
        switch(value) {
          case 'createMealPlan':
            if (that.storageService.getLocalItem(LocalStorageEnum.FORCE_TOUR_NAME) !== ToursEnum.REGISTER_MEAL_PLAN) {
              // Si está haciendo el tour como usuario nuevo, completa este tour y comienza el tour de asesoría
              await that.store.dispatch(new Loader(true, 'Completando tour'));
              await that.completeTour(ToursEnum.REGISTER_MEAL_PLAN);
              if (!user) return;
              await that.router.navigate(['/', 'clinic', clinicId, 'summary']);
              // await that.showTour('dashboard-expert'); // En el switch de este método es donde se define que tour es el siguiente
              await that.store.dispatch(new Loader(false));
            }
            break;
          case 'goToTours':
            that.completeTour(ToursEnum.REGISTER_MEAL_PLAN).finally(async () => {
              await that.completeService();
              if (!user) return;
              await that.router.navigate(['/', 'clinic', clinicId, 'profile', 'expert', 'me', 'tours']);
            });
            break;
          case 'keepMeHere':
            that.completeTour(ToursEnum.REGISTER_MEAL_PLAN).finally(async () => {
              await that.completeService();
            });
            break;
        }
      }
    }))

    this.shepherdService.confirmCancel = false;
    this.shepherdService.start();
  }

  /**
   * Crea un plan de alimentación desde cero y lo asigna a un paciente
   */
  startTourAssignCreateMealPlanSteps() {
    this.shepherdService.tourName = ToursEnum.REGISTER_MEAL_PLAN;
    this.completeService();
    setTimeout(async () => {
      await firstValueFrom(this.store.dispatch(new PatientSphereAction.ShowOrHideBubble(false)));
      this.utilitiesServiceService.showOrHideTypebot(false);
    }, 500);
    this.shepherdService.defaultStepOptions = this.defaultStepOptions;
    this.shepherdService.modal = true;
    this.shepherdService.addSteps(assignCreateMealPlanStep({
      steps: {default: this.stepOption},
      buttons: {cancel: this.cancelButton},
      services: {utilitiesService: this.utilitiesServiceService},
      events: {events: this.events},
    }));
    this.shepherdService.confirmCancel = false;
    this.shepherdService.start();
  }


  /**
   *
   */
  startTourAssignSelectMealPlanSteps() {
    this.shepherdService.tourName = ToursEnum.ASSIGN_SELECT_MEAL_PLAN;
    this.completeService();
    setTimeout(async () => {
      await firstValueFrom(this.store.dispatch(new PatientSphereAction.ShowOrHideBubble(false)));
      this.utilitiesServiceService.showOrHideTypebot(false);
    }, 500);
    this.shepherdService.defaultStepOptions = this.defaultStepOptions;
    this.shepherdService.modal = true;
    this.shepherdService.addSteps(assignMealPlanSelectStep({
      steps: {default: this.stepOption},
      buttons: {cancel: this.cancelButton}
    }));
    this.shepherdService.confirmCancel = false;
    this.shepherdService.start();
  }

  startTourAssignSelectMealPlanBuilderSteps() {
    this.shepherdService.tourName = ToursEnum.ASSIGN_SELECT_MEAL_PLAN;
    this.completeService();
    setTimeout(async () => {
      await firstValueFrom(this.store.dispatch(new PatientSphereAction.ShowOrHideBubble(false)));
      this.utilitiesServiceService.showOrHideTypebot(false);
    }, 500);
    this.shepherdService.defaultStepOptions = this.defaultStepOptions;
    this.shepherdService.modal = true;
    this.shepherdService.addSteps(assignMealPlanBuilderSelectStep({
      steps: {default: this.stepOption},
      buttons: {cancel: this.cancelButton},
      services: {utilitiesService: this.utilitiesServiceService},
      events: {events: this.events},
    }));
    this.shepherdService.confirmCancel = false;
    this.shepherdService.start();
  }

  startTourAssignMealPlanSteps() {
    this.shepherdService.tourName = ToursEnum.ASSIGN_SELECT_MEAL_PLAN;
    this.completeService();
    setTimeout(async () => {
      await firstValueFrom(this.store.dispatch(new PatientSphereAction.ShowOrHideBubble(false)));
      this.utilitiesServiceService.showOrHideTypebot(false);
    }, 500);
    const that = this;
    this.shepherdService.defaultStepOptions = this.defaultStepOptions;
    this.shepherdService.modal = true;
    this.shepherdService.addSteps(assignMealPlanPatientStep({
      steps: {default: this.stepOption},
      buttons: {cancel: this.cancelButton},
      services: {utilitiesService: this.utilitiesServiceService},
      events: {events: this.events},
      async cb() {
        await firstValueFrom(that.store.dispatch(new PatientSphereAction.ShowOrHideBubble(true)));
        that.utilitiesServiceService.showOrHideTypebot(true);

        await firstValueFrom(that.store.dispatch(new Loader(true, 'Finalizando el tour')));
        const forceTourName = that.storageService.getLocalItem(LocalStorageEnum.FORCE_TOUR_NAME);

        await that.completeTour(ToursEnum.ASSIGN_SELECT_MEAL_PLAN);
        that.completeService();
        const {user} = that.storageService.getLocalItem<ICredentials>(LocalStorageEnum.USER);
        if (!user) return;
        const clinicId = that.userService.getClinicIdFromUser(user);

        if (forceTourName) {
          await that.router.navigate(['/', 'clinic', clinicId, 'profile', 'expert', 'me', 'tours']);
        } else {
          await that.router.navigate(['/', 'clinic', clinicId, 'summary']);
        }
        await firstValueFrom(that.store.dispatch(new Loader(false)));
      },
    }));
    this.shepherdService.confirmCancel = false;
    this.shepherdService.start();
  }

  /**
   * LS complete tour
   * @param tour
   * @param deleteDemoData
   */
  async completeTour(tour: ToursEnum, deleteDemoData = true): Promise<void> {
    const clinic: IClinic = cloneDeep(await firstValueFrom((this.store.selectOnce(ClinicState.getClinicSelected))));
    const userAndToken = this.storageService.getLocalItem<{ user: IUser, token: string }>('user');
    if (!userAndToken || !userAndToken.user || !userAndToken.user.metadata || !userAndToken.user.metadata.tours) return;
    try {
      await firstValueFrom((this.store.dispatch(new TourAction.CompleteOne(clinic?._id, tour, deleteDemoData))));
    } catch (e) {
      Logger.log(e);
    }

    // await firstValueFrom((this.store.dispatch(new CompleteAppoinmentTourAction(clinic?._id))));


    userAndToken.user.metadata.tours[tour] = true;
    this.storageService.setLocalItem(LocalStorageEnum.USER, userAndToken);
    this.storageService.removeLocalItem(LocalStorageEnum.FORCE_TOUR_NAME);
    this.tourMode = false;
    this.requiredMainMenu = false;

    await firstValueFrom(this.store.dispatch(new AppointmentActions.ResetState()));
    await firstValueFrom(this.store.dispatch(new MealPlanActions.Clear()));
    await firstValueFrom(this.store.dispatch(new TourAction.ResetState()));
    if (tour !== ToursEnum.REGISTER_PATIENT) {
      await firstValueFrom(this.store.dispatch(new PatientAction.ResetState()));
    }
  }


  /**
   *
   * @param deleteDemoData delete all demo data of the tours.
   */
  async completeAllTour(deleteDemoData = true): Promise<void> {
    const clinic: IClinic = cloneDeep(await firstValueFrom((this.store.selectOnce(ClinicState.getClinicSelected))));
    const userAndToken: ICredentials = this.storageService.getLocalItem<ICredentials>(LocalStorageEnum.USER);
    if (!userAndToken || !userAndToken.user || !userAndToken.user.metadata || !userAndToken.user.metadata.tours) return;
    try {
      await firstValueFrom((this.store.dispatch(new TourAction.CompleteAll(clinic?._id, deleteDemoData))));
    } catch (e) {
      Logger.log(e);
    }
    for (const prop in userAndToken.user.metadata.tours) {
      userAndToken.user.metadata.tours[prop] = true;
    }
    this.storageService.setLocalItem('user', userAndToken);
    this.storageService.removeLocalItem(LocalStorageEnum.FORCE_TOUR_NAME);
    this.tourMode = false;
    this.requiredMainMenu = false;
    await this.openMenu(false);
  }


  completeService(): void {

    if (this.shepherdService.isActive) {
      this.shepherdService.complete();
    }
  }

  /**
   * Comprueba si hay recetas para hacer el tour con una receta
   * en caso contrario hace el tour sin recetas
   * @param clinicId
   */
  async checkHasFoodDishes(clinicId: string): Promise<void> {
    try {
      const filter: ServiceLoopbackFilters = {
        limit: 20,
        skip: 0,
        order: 'name ASC',
        include: []
      };
      await firstValueFrom((this.store.dispatch(new FoodGroupAction.GetByClinicId(clinicId, filter))));
      const foodDishes = cloneDeep(await firstValueFrom((this.store.selectOnce(FoodGroupState.getFoodGroups))));
      if (foodDishes && foodDishes.length > 0) {
        this.startTourRegisterMealPlanPartTwo();
      } else {
        this.startTourRegisterMealPlanPartNotFoodDishes();
      }
    } catch (e) {
      this.startTourRegisterMealPlanPartNotFoodDishes();
      Logger.log('Ocurrió un error', e);
    }
  }

  async openMenu(value: boolean): Promise<void> {
    await this.store.dispatch(new PanelUtilitiesActions.MainMenuActive(value));
  }

  closeTour(): void {
    this.shepherdService.hide();
  }

  public get getIsCollapsedMenu(): Observable<boolean> {
    return this.isCollapsedMenu.asObservable();
  }

  forceCloseTour(): void {
    if (this.shepherdService.isActive) {
      this.requiredMainMenu = false;
      this.shepherdService.complete();
    }
  }

  /**
   * Utility method for BeforeShowPromise Step
   * @param timeout
   * @private
   */
  private beforeShowPromise(timeout = 500): Promise<boolean> {
    return new Promise(function (resolve) {
      setTimeout(function () {
        resolve(true);
      }, timeout);
    });
  }

  /**
   *
   * @param clinicId
   */
  async canViewRegisterBranchTour(clinicId?: string): Promise<boolean> {
    let indicators = await firstValueFrom(this.store.selectOnce(PlanState.getIndicatorsSubscription));
    if (!indicators) {
      await firstValueFrom(this.store.dispatch(new PlanActions.GetIndicators(clinicId)));
      indicators = await firstValueFrom(this.store.selectOnce(PlanState.getIndicatorsSubscription));
      if (!indicators) return false;
    }

    return indicators?.branch?.count < indicators?.branch?.limit;
  }

  async showTour(urlView: string): Promise<void> {
    this.urlView = urlView;
    const user = this.storageService.getLocalItem<{ token: string; user: IUser; }>('user')?.user;
    if (!user || !user.experts || !user.metadata || !user.metadata.tours) return;
    const isAdmin = await this.userService.getExpertIsAdmin();
    const isOnlyExpert = await this.userService.getIsOnlyExpert();
    const clinic: IClinic = await firstValueFrom(this.store.selectOnce(ClinicState.getClinicSelected));
    const forceTourName = this.storageService.getLocalItem(LocalStorageEnum.FORCE_TOUR_NAME);
    if (forceTourName) {
      if (urlView === 'food-dish-list' && forceTourName === ToursEnum.REGISTER_FOOD_DISH) {
        return await this.initTourFoodDishMenu();
      } else if (urlView === 'food-dish' && forceTourName === ToursEnum.REGISTER_FOOD_DISH) {
        return await this.initTourFoodDishSteps();
      } else if (urlView === 'meal-plan-list' && forceTourName === ToursEnum.REGISTER_MEAL_PLAN) {
        return await this.initTourRegisterMealPlanListStps();
      } else if (urlView === 'meal-plan' && forceTourName === ToursEnum.REGISTER_MEAL_PLAN) {
        return await this.initTourRegisterMealPlanSteps();
      } else if (urlView === 'patients' && forceTourName === ToursEnum.REGISTER_PATIENT) {
        return await this.initTourPatientSteps();
      } else if (urlView === 'patient-information-page' && forceTourName === ToursEnum.REGISTER_PATIENT) {
        return await this.initTourScheduleAppointmentFromConsultation();
      } else if (urlView === 'schedules' && forceTourName === ToursEnum.CHECK_SCHEDULE) {
        return await this.initTourCheckScheduleSteps();
      } else if (urlView === 'work-schedules' && forceTourName === ToursEnum.SCHEDULES) {
        return await this.initTourWorkSchedulesSteps();
      } else if (urlView === 'register-branch' && forceTourName === ToursEnum.REGISTER_BRANCH) {
        return await this.initTourRegisterBranchSteps();
      } else if (urlView === 'dashboard-expert' && forceTourName === ToursEnum.SCHEDULE_APPOINTMENT) {
        return await this.initTourHomeAppointmentMenu();
      } else if (urlView === 'dashboard-expert' && forceTourName === ToursEnum.ADVICE) {
        return await this.initTourAdviceMenu();
      } else if (forceTourName === 'assignCreateMealPlan') {
        // START TOUR CREATE MEAL PLAN
        await firstValueFrom(this.store.dispatch(new TourAction.CreateDemoPatient(clinic._id)));
        const demoPatient = await firstValueFrom(this.store.selectOnce(TourState.getDemoPatientCreated));
        if (!demoPatient) return ;

        this.storageService.setLocalItem(LocalStorageEnum.FORCE_TOUR_NAME, ToursEnum.ASSIGN_CREATE_MEAL_PLAN);
        await this.router.navigate(['/', 'clinic', clinic._id, 'patients', demoPatient._id, 'meal-plans']);
        return;
      } else if (forceTourName === 'assignSelectMealPlan') {
        // START TOUR SELECT MEAL PLAN
        await firstValueFrom(this.store.dispatch(new TourAction.CreateDemoPatient(clinic._id)));
        const demoPatient = await firstValueFrom(this.store.selectOnce(TourState.getDemoPatientCreated));
        this.storageService.setLocalItem(LocalStorageEnum.FORCE_TOUR_NAME, ToursEnum.ASSIGN_SELECT_MEAL_PLAN);
        const expert = this.userService.getExpertId(this.storageService.getLocalItem<ICredentials>(LocalStorageEnum.USER).user);
        await this.router.navigate(['/', 'clinic', clinic._id, 'patients', demoPatient._id, 'meal-plans'], {queryParams: {expert}});
        return;
      } else if (forceTourName === 'checkSchedule') {
        return await this.initTourCheckScheduleMenu();
      } else if (forceTourName === 'registerFoodDish') {
        return await this.initTourRegisterFoodDishMenu();
      } else if (forceTourName === 'registerMealPlan') {
        return await this.initTourRegisterMealPlanMenu();
      } else if (forceTourName === 'registerPatient') {
        return await this.initTourRegisterPatientMenu();
      } else if (forceTourName === 'schedules') {
        return await this.initTourRegisterWorkScheduleMenu();
      }
    }
    this.tours = user.metadata.tours;
    switch (urlView) {
      case 'dashboard-expert': {
        if (user.metadata.tours.schedules === false && isAdmin) { // Horarios de la clínica - Tour 1 (abre menú)
          await this.initTourRegisterWorkScheduleMenu();
        } else if (user.metadata.tours.expertSchedules === false && isOnlyExpert) { // Horario del experto - Tour 1 (abre menú Experto no admin)
          // todo: por ahora pondre esta condicional para que solo tenga tour cuando si puede hacer su horario
          // porque aun no trabajo el tour cuando la clínica no permite hacer horario propio
          if (!clinic) return;
          if (clinic.expertCanDefineSchedules) {
            await this.initTourRegisterWorkScheduleOnlyExpertMenu();
          }
          // iniciar tour de horarios del solo experto
        } else if (user.metadata.tours.registerPatient === false) { // Registrar paciente - Tour 2 (abre menú)
          await this.initTourRegisterPatientMenu();
        } else if (user.metadata.tours.checkSchedule === false) { // Revisar agenda - Tour 4 (abre menú)
          await this.initTourCheckScheduleMenu();
        } else if (user.metadata.tours.registerFoodDish === false) { // Crear receta - Tour 5 (abre menú)
          await this.initTourRegisterFoodDishMenu();
        } else if (user.metadata.tours.registerMealPlan === false) { // Listado de planes de alimentación - Tour 6 (abre menú)
          await this.initTourRegisterMealPlanMenu();
        } else if (user.metadata.tours.advice === false) {  // Asesoría - Tour 7 (abre menú)
          // this.storageService.getLocalItem(LocalStorageEnum.FORCE_TOUR_NAME) === ToursEnum.ADVICE
          if (!this.router.url.includes('summary')) { // Validación para redireccionar a summary-page para poder realizar el tour
            const clinicId = this.userService.getClinicIdFromUser(user);
            await this.router.navigate(['/', 'clinic', clinicId, 'summary']);
            return;
          }
          await this.initTourAdviceMenu();
        } else if (user.metadata.tours.scheduleAppointment === false) { // Registra cita - Tour 3 (alternativa al tour de crear cita)
          // this.storageService.getLocalItem(LocalStorageEnum.FORCE_TOUR_NAME) === ToursEnum.SCHEDULE_APPOINTMENT
          await this.initTourHomeAppointmentMenu();
        } else {
          // await this.router.navigate(['/clinic', clinic._id, 'summary']);
        }/* else if (user.metadata.tours.registerBranch === false) {
          // Este tour es opcional y solo se podrá ejecutar desde el listado de tours
          await this.initTourRegisterBranchMenu();
        }*/

        break;
      }
      case 'work-schedules': { // Horarios de la clínica - Tour 1
        // this.storageService.getLocalItem(LocalStorageEnum.FORCE_TOUR_NAME) === ToursEnum.SCHEDULES
        if (user.metadata.tours.schedules === false) {
          await this.initTourWorkSchedulesSteps();
        } else {
          this.completeService();
        }
        break;
      }
      case 'work-expert-schedules': { // Horarios de la clínica solo como experto - Tour 1
        if (user.metadata.tours.expertSchedules === false) {
          // verificar si la clínica permite hacer horarios al experto
          if (!clinic) return;
          if (clinic.expertCanDefineSchedules) {
            await this.initTourWorkSchedulesOnlyExpertSteps();
          } else {
            await this.initTourWorkSchedulesOnlyExpertWithoutPermissionToEditSteps();
          }
        } else {
          this.completeService();
        }
        break;
      }
      case 'patients': { // Registrar paciente - Tour 2
        // this.storageService.getLocalItem(LocalStorageEnum.FORCE_TOUR_NAME) === ToursEnum.REGISTER_PATIENT
        if (user.metadata.tours.registerPatient === false) {
          await this.initTourPatientSteps();
        } else {
          await this.openMenu(false);
          this.completeService();
        }
        break;
      }
      case 'patient-information-page': { // Crear cita desde los detalles del paciente - Tour 3
        // this.storageService.getLocalItem(LocalStorageEnum.FORCE_TOUR_NAME) === ToursEnum.REGISTER_PATIENT
        if (user.metadata.tours.scheduleAppointment === false) {
          await this.initTourScheduleAppointmentFromConsultation();
        } else if (user.metadata.tours.checkSchedule === false) {
          await this.initTourCheckScheduleMenu();
        } else {
          this.completeService();
        }
        break;
      }
      case 'schedules': { // Revisar agenda - Tour 4
        // this.storageService.getLocalItem(LocalStorageEnum.FORCE_TOUR_NAME) === ToursEnum.CHECK_SCHEDULE
        if (user.metadata.tours.checkSchedule === false) {
          await this.initTourCheckScheduleSteps();
        } else {
          this.completeService();
        }
        break;
      }
      case 'food-dish-list': { // Crear receta - Tour 5 (listado de recetas)
        await this.openMenu(false);
        // || this.storageService.getLocalItem(LocalStorageEnum.FORCE_TOUR_NAME) === ToursEnum.REGISTER_FOOD_DISH
        if (user.metadata.tours.registerFoodDish === false) {
          await this.initTourFoodDishMenu();
        } else {
          this.completeService();
        }
        break;
      }
      case 'food-dish': { // Crear receta - Tour 5.1 (creación de la receta)
        // this.storageService.getLocalItem(LocalStorageEnum.FORCE_TOUR_NAME) === ToursEnum.REGISTER_FOOD_DISH
        if (user.metadata.tours.registerFoodDish === false) {
          await this.initTourFoodDishSteps();
        } else {
          await this.openMenu(false);
          this.completeService();
        }
        break;
      }
      case 'meal-plan-list': { // Listado de planes de alimentación - Tour 6 (Listado de planes)
        // this.storageService.getLocalItem(LocalStorageEnum.FORCE_TOUR_NAME) === ToursEnum.REGISTER_MEAL_PLAN
        if (user.metadata.tours.registerMealPlan === false) {
          await this.initTourRegisterMealPlanListStps();
        } else {
          await this.openMenu(false);
          this.completeService();
        }
        break;
      }
      case 'meal-plan': { // Creación de plan de alimentación - Tour 6.1
        // this.storageService.getLocalItem(LocalStorageEnum.FORCE_TOUR_NAME) === ToursEnum.REGISTER_MEAL_PLAN
        if (user.metadata.tours.registerMealPlan === false) {
          await this.initTourRegisterMealPlanSteps();
        } else {
          await this.openMenu(false);
          this.completeService();
        }
        break;
      }
      case 'advice': { // Asesoría - Tour 7
        await this.initTourAdviceSteps();
        break;
      }
      /*
      TODO: Agregar validación para que solo se ejecute si el plan (suscripción) tiene más sucursales para crear
      case 'register-branch': // Registrar sucursal
        // this.storageService.getLocalItem(LocalStorageEnum.FORCE_TOUR_NAME) === ToursEnum.REGISTER_BRANCH
        if (user.metadata.tours.registerBranch === false) {
          await this.initTourRegisterBranchSteps();
        } else {
          this.completeService();
        }
        break;*/
      default: { }
    }
  }

  async initTourCheckScheduleSteps() {
    this.tourMode = true;
    this.requiredMainMenu = false;
    await this.openMenu(false);
    this.startTourViewSchedulesSteps();
  }

  async initTourScheduleAppointmentFromConsultation(): Promise<void> {
    this.tourMode = true;
    this.requiredMainMenu = false;
    await this.openMenu(false);
    // Abrir el plan de alimentación collapsable
    this.isCollapsedMenu.next(false);
    setTimeout(() => {
      this.startTourNewAppointmentFromConsultation();
    }, 500);
  }

  async initTourPatientSteps(): Promise<void> {
    this.tourMode = true;
    this.requiredMainMenu = false;
    await this.openMenu(false);
    this.startTourRegisterPatientSteps();
  }

  async initTourRegisterMealPlanSteps() {
    const {user} = this.storageService.getLocalItem<ICredentials>('user');
    if (!user) return;

    this.tourMode = true;
    this.requiredMainMenu = false;
    await this.openMenu(false);
    // Abrir el plan de alimentación collapsable
    this.isCollapsedMenu.next(false);
    // verificar si existe al menos un platillo
    await this.checkHasFoodDishes(user.experts[0].clinicId);
  }

  async initTourRegisterMealPlanListStps(): Promise<void> {
    this.tourMode = true;
    this.requiredMainMenu = false;
    await this.openMenu(false);
    this.startTourRegisterMealPlanMenu();
  }

  async initTourFoodDishSteps(): Promise<void> {
    this.tourMode = true;
    this.requiredMainMenu = false;
    await this.openMenu(false);
    this.startTourRegisterFoodDishSteps();
  }

  async initTourFoodDishMenu() {
    this.tourMode = true;
    this.requiredMainMenu = false;
    await this.openMenu(false);
    this.startTourRegisterFoodDishMenu();
  }

  /**
   * Grupos de Horarios
   */
  async initTourWorkSchedulesSteps() {
    this.tourMode = true;
    this.requiredMainMenu = false;
    await this.openMenu(false);
    setTimeout(() => {
      this.startTourWorkSchedulesSteps();
    }, 500);
  }

  /**
   * Grupos de Horarios solo como experto cuando la clínica permite hacer horario
   */
  async initTourWorkSchedulesOnlyExpertSteps() {
    this.tourMode = true;
    this.requiredMainMenu = false;
    await this.openMenu(false);
    setTimeout(() => {
      this.startTourWorkSchedulesOnlyExpertSteps();
    }, 500);
  }

  /**
   * Grupos de horarios solo como experto cuando la clínica no permite modificar horarios
   */
  async initTourWorkSchedulesOnlyExpertWithoutPermissionToEditSteps() {
    this.tourMode = true;
    this.requiredMainMenu = false;
    await this.openMenu(false);
    setTimeout(() => {
      this.startTourWorkSchedulesOnlyExpertWithoutPermissionToEditSteps();
    }, 500);
  }

  async initTourRegisterBranchSteps(): Promise<void> {
    this.tourMode = true;
    this.requiredMainMenu = false;
    await this.openMenu(false);
    await firstValueFrom(this.store.dispatch(new  PanelUtilitiesActions.SetIsVisible(true)));
    setTimeout(() => {
      this.startTourBranchSteps();
    }, 500);
  }

  async initTourAdviceSteps(): Promise<void> {
    this.tourMode = true;
    this.requiredMainMenu = false;
    await this.openMenu(false);
    await firstValueFrom(this.store.dispatch(new  PanelUtilitiesActions.SetIsVisible(true)));
    await firstValueFrom(this.store.dispatch(new PatientSphereAction.ShowOrHideBubble(false)));
    setTimeout(() => {
      this.startTourAdviceSteps();
    }, 500);
  }

  async initTourAdviceMenu(): Promise<void> {
    await firstValueFrom(this.store.dispatch(new Loader(true, 'Cargando tour')));
    setTimeout(() => {
      this.utilitiesServiceService.showOrHideTypebot(false);
    }, 1000);

    const {user} = this.storageService.getLocalItem<ICredentials>(LocalStorageEnum.USER);
    if (!user) return;


    const clinicId = this.userService.getClinicIdFromUser(user);
    await firstValueFrom(this.store.dispatch(new TourAction.CreateDemoAppointment(clinicId)));
    const demoAppointment = await firstValueFrom(this.store.selectOnce(TourState.getDemoAppointmentCreated));
    await this.store.dispatch(new AppointmentActions.AddAppointment(demoAppointment));

    setTimeout(async () => {
      this.startTourAdvice();
      await firstValueFrom(this.store.dispatch(new Loader(false)));
    }, 500);
  }


  async initTourCheckScheduleMenu(): Promise<void> {
    this.tourMode = true;
    this.requiredMainMenu = true;
    await this.openMenu(true);
    this.startTourGoToSchedule();
  }

  async initTourHomeAppointmentMenu(): Promise<void> {
    this.tourMode = true;
    this.requiredMainMenu = false;
    await this.openMenu(false);
    this.isCollapsedMenu.next(false);
    const {user} = this.storageService.getLocalItem<ICredentials>(LocalStorageEnum.USER);
    if (!user) return ;
    const clinicId = this.userService.getClinicIdFromUser(user);
    await firstValueFrom((this.store.dispatch(new TourAction.CreateDemoPatient(clinicId))));
    this.startTourNewAppointmentFromHomePage();
  }

  async initTourRegisterPatientMenu(): Promise<void> {
    this.tourMode = true;
    this.requiredMainMenu = true;
    await this.openMenu(true);
    this.startTourGoToPatients();
  }

  async initTourRegisterFoodDishMenu(): Promise<void> {
    this.tourMode = true;
    this.requiredMainMenu = true;
    await this.openMenu(true);
    this.startTourGoToFoodDishes();
  }

  async initTourRegisterMealPlanMenu(): Promise<void> {
    this.tourMode = true;
    this.requiredMainMenu = true;
    await this.openMenu(true);
    this.startTourGoToMealPlans();
  }

  async initTourRegisterWorkScheduleMenu(): Promise<void> {
    this.tourMode = true;
    this.requiredMainMenu = true;
    await this.openMenu(true);
    this.startTourGoToAdministration('¡Vamos a crear un horario de trabajo!');
  }

  async initTourRegisterWorkScheduleOnlyExpertMenu(): Promise<void> {
    this.tourMode = true;
    this.requiredMainMenu = true;
    await this.openMenu(true);
    this.startTourGotoProfile('¡Vamos a revisar los horarios de trabajo!');
  }

  async initTourRegisterBranchMenu() {
    this.tourMode = true;
    this.requiredMainMenu = true;
    await this.openMenu(true);
    this.startTourGoToAdministration('¡Vamos a crear una sucursal!');
  }


  /**
   * Tour para asignar un plan de alimentación a un paciente
   */
  async initTourAssignCreateMealPlanToPatientSteps(): Promise<void>{
    this.tourMode = true;
    this.requiredMainMenu = false;
    await this.openMenu(false);
    this.startTourAssignCreateMealPlanSteps();
  }

  /**
   * Tour para asignar un plan de alimentación a un paciente
   */
  async initTourAssignMealPlanToPatientSteps(): Promise<void>{
    this.tourMode = true;
    this.requiredMainMenu = false;
    await this.openMenu(false);
    this.startTourAssignSelectMealPlanSteps();
  }
  /**
   * Tour para asignar un plan de alimentación a un paciente desde el componente meal plan builder
   */
  async initTourAssignSelectMealPlanBuilderToPatientSteps(): Promise<void> {
    this.tourMode = true;
    this.requiredMainMenu = false;
    await this.openMenu(false);
    this.startTourAssignSelectMealPlanBuilderSteps();
  }
  /**
   * Tour para asignar un plan de alimentación a un paciente desde el componente meal plan
   */
  async initTourAssignMealPlanPatientSteps(): Promise<void> {
    this.tourMode = true;
    this.requiredMainMenu = false;
    await this.openMenu(false);
    this.startTourAssignMealPlanSteps();
  }



}
